import { DESC } from '@utils/table/constants';
import moment from 'moment';
import { defaultSubscriberColumns } from '@components/viewer-module/SubscribersTable/utils';
import update from 'immutability-helper';
import types from './types';

export const ORIGIN_SEARCH_SORT = {
  columnKey: '',
  searchText: {},
  order: DESC,
  columnOrderKey: 'SessionStartTime',
};

export const initialState = {
  viewerId: null,
  filterId: null, // All Traffic filter id
  interval: {
    startDate: moment().subtract(1, 'days').format(),
    endDate: moment().format(),
    days: 1,
    isCustom: false,
    isLive: false,
  },
  searchSortData: { ...ORIGIN_SEARCH_SORT }, // Search and Sort
  showAdvanceDetails: false,
  rowData: {
    sessionId: 'NA',
  },
  geoData: {
    startTime: 0,
    asn: 0,
    encodedGeo: 0,
    city: 0,
  },
  enableSortSearchExport: false,
  tableColumns: [],
  selectedColumns: [...defaultSubscriberColumns()],
  anchoredColumns: {},
  advanceToggle: false,
};

const switchMap = {};

switchMap[types.UPDATE] = (state, action) => {
  const { persistedState } = action;
  return update(state, {
    $merge: {
      ...persistedState,
    },
  });
};

switchMap[types.INIT] = (state) =>
  update(state, {
    $set: initialState,
  });

switchMap[types.SET_DATE] = (state, action) => {
  return update(state, {
    interval: {
      days: { $set: action.days },
      isCustom: { $set: false },
    },
  });
};

switchMap[types.SET_INTERVAL] = (state, action) => {
  return update(state, {
    interval: { $set: action.interval },
  });
};

switchMap[types.SET_ADVANCED] = (state, action) => {
  return update(state, {
    showAdvanceDetails: { $set: action.showAdvanceDetails },
  });
};

switchMap[types.SET_ROWDATA] = (state, action) => {
  return update(state, {
    rowData: { $set: action.rowData },
  });
};

switchMap[types.SET_GEODATA] = (state, action) => {
  return update(state, {
    geoData: { $set: action.geoData },
  });
};

switchMap[types.SET_ENABLESSE] = (state, action) => {
  return update(state, {
    enableSortSearchExport: { $set: action.enableSSE },
  });
};

switchMap[types.SET_SEARCH_SORT_DATA] = (state, action) => {
  return update(state, {
    searchSortData: {
      $set: update(state.searchSortData, { $merge: action.searchSortData }),
    },
  });
};

switchMap[types.RESET_SEARCH_SORT] = (state) => {
  return update(state, {
    searchSortData: {
      $set: update(state.searchSortData, { $merge: ORIGIN_SEARCH_SORT }),
    },
  });
};

// set persisted columns here also used UPDATE to test
switchMap[types.SET_SELECTED_COLUMNS] = (state, action) => {
  return update(state, {
    selectedColumns: {
      $set: action.selectedColumns,
    },
  });
};

switchMap[types.SET_TABLE_COLUMNS] = (state, action) => {
  return update(state, {
    tableColumns: { $set: action.tableColumns },
  });
};

switchMap[types.SET_ANCHORED_COLUMNS] = (state, action) => {
  const originalValue = state.anchoredColumns[action.anchoredColumns] || false;
  return update(state, {
    anchoredColumns: {
      $set: { ...state.anchoredColumns, [action.anchoredColumns]: !originalValue },
    },
  });
};

switchMap[types.SET_ADVANCED_TOGGLE] = (state, action) => {
  return update(state, {
    advanceToggle: { $set: action.advanceToggle },
  });
};

export default (state = initialState, action) =>
  switchMap[action.type] ? switchMap[action.type](state, action) : state;
